<script setup>

import KdContainer from "./kdContainer.vue";


</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
      <el-form-item label="指派人员" prop="assignUser">
        <el-select filterable clearable v-model="form.assignUser" placeholder="请选择指派人员">
          <el-option
            v-for="item in userOptions"
            :key="item.staffAccountId"
            :label="item.staffName"
            :value="item.staffAccountId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理意见">
        <el-input type="textarea" placeholder="请输入处理意见" v-model="handlingText" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
      </el-form-item>
      <el-form-item>
        <drag-upload
          ref="uploadFile"
          :accessoryList.sync="form.file"
          :httpRequest="imAction"/>
      </el-form-item>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
          <el-button type="danger" @click="auditRejectBtClick">驳回</el-button>     </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";
import {getAccountQEUserKDList} from "@/api/api";

export default {
  name: "kdMarketEngineerAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    countryDataId:String
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      userOptions:[],
      assignUser:"",
      dialogVisible:false,
      auditPassDialogVisible: false,
      handlingText: "",
      form:{
        assignUser: "",
        handSuggestion: "",
        file: [],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        assignUser:[
          {required: true, message: "指派人员不能为空", trigger: ["blur", "change"]}
        ],
        rejectReason: [
          { required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]}
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    }
  },
  methods: {
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        handlingText: this.handlingText,
        faultVideoList: this.form.file,
        variables: {
          approval: true,
          QEAssignee: this.form.assignUser,
        },
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    },
    listAccountQEUser(){
      let urlSearchParams = new URLSearchParams();
      urlSearchParams.append("questionId", this.questionId);
      urlSearchParams.append("countryDataId", this.countryDataId);
      getAccountQEUserKDList(urlSearchParams).then(res => {
        if(res.status == "0"){
          this.userOptions = res.data;
        }
      })
    }
  },mounted() {
    this.listAccountQEUser();
  }
}
</script>
